var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmediateAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7937 10.6486C16.8755 10.5509 16.8061 10.4023 16.6787 10.4023H13.2479C13.1494 10.4023 13.0777 10.309 13.1029 10.2138L14.4461 5.15171C14.4873 4.99667 14.2891 4.89396 14.1861 5.01693L7.20627 13.3514C7.12451 13.4491 7.19393 13.5977 7.32127 13.5977H10.7521C10.8506 13.5977 10.9223 13.691 10.8971 13.7862L9.55388 18.8483C9.51274 19.0033 9.71088 19.106 9.81386 18.9831L16.7937 10.6486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmediateAttention);
export default __webpack_public_path__ + "static/media/immediate-attention.3d15d569557175273ee9a809853f767a.svg";
export { ForwardRef as ReactComponent };